import { DisplayMarketAsset, MerklReward, PointsItem } from "@silo/types";
import {
  CollateralAprMetrics,
  DebtAprMetrics,
  getCollateralAprMetrics,
  getDebtAprMetrics,
  getDisplayCollateralYields,
  getProtectedAprMetrics,
  ProtectedAprMetrics,
} from "@silo/utils";

export type YieldMetrics = CollateralAprMetrics &
  ProtectedAprMetrics &
  DebtAprMetrics & {
    hasDepositRewards: boolean;
    hasDepositIncentives: boolean;
    displayCollateralYields: boolean;
    depositPoints: readonly PointsItem[];
    depositMerklRewards: readonly MerklReward[];
  };

export function getYieldMetrics(
  asset: DisplayMarketAsset,
  nativeRewardsSymbol: string
): YieldMetrics {
  const {
    depositMode,
    collateralPoints,
    protectedPoints,
    collateralMerklRewards,
    protectedMerklRewards,
  } = asset;

  const displayCollateralYields = getDisplayCollateralYields(depositMode);

  const collateralMetrics = getCollateralAprMetrics(asset, nativeRewardsSymbol);

  const protectedMetrics = getProtectedAprMetrics(asset, nativeRewardsSymbol);

  const debtMetrics = getDebtAprMetrics(asset, nativeRewardsSymbol);

  const hasDepositRewards = displayCollateralYields
    ? collateralMetrics.hasCollateralRewards
    : protectedMetrics.hasProtectedRewards;

  const hasDepositIncentives = displayCollateralYields
    ? collateralMetrics.hasCollateralRewards
    : protectedMetrics.hasProtectedIncentives;

  const depositPoints = displayCollateralYields
    ? collateralPoints
    : protectedPoints;

  const depositMerklRewards = displayCollateralYields
    ? collateralMerklRewards
    : protectedMerklRewards;

  const yieldMetrics: YieldMetrics = {
    ...collateralMetrics,
    ...protectedMetrics,
    ...debtMetrics,

    displayCollateralYields,
    hasDepositRewards,
    hasDepositIncentives,
    depositPoints,
    depositMerklRewards,
  };

  return yieldMetrics;
}
